module.exports = __webpack_public_path__ + "img/it-badge.53329af4.png";